"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../types/types.generic");
var _actionUtils = require("../../utils/actionUtils");
var setMultipleAttendeeCameraStatuses = function setMultipleAttendeeCameraStatuses(cameraStatuses) {
  return (0, _actionUtils.actionCreator)(_types.SET_MULTIPLE_ATTENDEE_CAMERA_STATUSES, cameraStatuses);
};
var _default = exports["default"] = setMultipleAttendeeCameraStatuses;